import { useFormContext } from "react-hook-form";

import { useTranslation } from "@flare/i18n";
import { Text } from "@flare/ui/components";

import { ZipCode } from "@/components/Funnel/zip-code/zip-code";

import { ActionButton } from "../components/action-button";
import { ActionsContainer } from "../components/actions-container";
import { BackButton } from "../components/back-button";
import { Footer } from "../components/footer";
import { InputsContainer } from "../components/inputs-container";
import { PrivacyDisclaimer } from "../components/privacy-disclaimer";
import { StepContainer } from "../components/step-container";
import { StepContent } from "../components/step-content";
import { StepFeedback } from "../components/step-feedback";
import { StepSubtitle } from "../components/step-subtitle";
import { StepTitle } from "../components/step-title";
import { useFunnelAnswers } from "../hooks/useFunnelAnswers";

import type { StepProps } from "./step.types";

export default function ZipCodeStep({ handlers, experiments }: StepProps) {
  const { onSkip } = handlers;
  const { abTestDivorceFlowEnabled } = experiments;
  const { t } = useTranslation();

  const { watch } = useFormContext();
  const { funnelAnswers } = useFunnelAnswers();
  const { subPractice } = funnelAnswers;
  const county = watch("county", funnelAnswers?.county);
  const state = watch("state", funnelAnswers?.state);
  const showFeedback = state !== "unsupported" && county;

  const feedback = showFeedback
    ? t("FUNNEL_ZIP_CODE_FEEDBACK", { county })
    : "";

  const isAbTestDivorceFlowEnabled =
    abTestDivorceFlowEnabled && subPractice === "divorce";

  const content = isAbTestDivorceFlowEnabled
    ? {
        title: t("FUNNEL_ZIP_CODE_TITLE_V1"),
        subTitle: t("FUNNEL_ZIP_CODE_SUBTITLE_V1"),
      }
    : {
        title: t("FUNNEL_ZIP_CODE_TITLE"),
        subTitle: t("FUNNEL_ZIP_CODE_SUBTITLE"),
      };

  return (
    <>
      <StepContainer>
        <StepContent>
          <BackButton />
          <StepTitle> {content.title}</StepTitle>
          <StepSubtitle>{content.subTitle}</StepSubtitle>
          <InputsContainer className="my-sp-9 max-w-[520px]">
            <ZipCode />
            <StepFeedback className="mb-sp-3 mt-sp-4">{feedback}</StepFeedback>
            <div className="mt-sp-2 w-full border-t border-primary pt-sp-5">
              <Text asChild textColor="action">
                <button type="button" onClick={onSkip}>
                  {t("FUNNEL_ZIP_CODE_SKIP")}
                </button>
              </Text>
            </div>
          </InputsContainer>
        </StepContent>
        <ActionsContainer>
          <PrivacyDisclaimer />
          <ActionButton>{t("FUNNEL_ACTION_BUTTON_NEXT")}</ActionButton>
        </ActionsContainer>
      </StepContainer>
      <Footer />
    </>
  );
}
